require('./bootstrap');

//const bootstrap = require('bootstrap');
import 'bootstrap/js/dist/carousel'

require('./linking');

/**
 * Initializing cookify
 */
// window.Cookify = require('cookify/src/index');
import Cookify from 'cookify/src/index';
window.Cookify = Cookify;